module.exports = __webpack_public_path__ + "static/media/AcordGDPR_Credex_20250403.1e089de9.pdf";